<script setup lang="ts">
import FootNotes from '~/components/text/FootNotes.vue';

const open = defineModel<boolean>('open');
</script>
<template>
  <USlideover v-model:open="open" class="sm:max-w-2xl">
    <template #title><UIcon name="heroicons:shopping-bag" /> {{ $t('cart') }}</template>
    <template #body>
      <LazyShopSideCart />
      <FootNotes> {{ $t('shop.discounts.footNote') }} </FootNotes>
    </template>
  </USlideover>
</template>
